import { clsx } from 'clsx';
import { type ComponentPropsWithRef } from 'react';

import s from './Icon.module.css';
import '@repo/ui/Icon/sprite.svg?inject-body';
import { type IconNames } from '@repo/ui/Icon/utils';

export const iconSizeOptions = ['xs', 'sm', 'md', 'mdr', 'lg', 'font'] as const;
export type IconSize = (typeof iconSizeOptions)[number];

export interface IconProps extends ComponentPropsWithRef<'div'> {
  className?: string;
  name: IconNames;
  size?: IconSize;
}

export const Icon = (props: IconProps) => {
  const { className, name, size = 'md', ...attrs } = props;

  return (
    <div
      className={clsx(s.icon, s[`${name}Icon`], s[`${size}Size`], className)}
      role="img"
      aria-hidden="true"
      {...attrs}
    >
      <svg
        width="100%"
        height="100%"
        role="presentation"
        focusable="false"
        className={s.svg}
      >
        <use xlinkHref={`#n-icon-${name}`} />
      </svg>
    </div>
  );
};
